var _rect, _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.199,
    y: 0.58,
    width: 13.877,
    height: 27.754,
    rx: 0.578,
    transform: "rotate(6 16.2 .58)",
    fill: "#D02F25"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.18.762c.01-.1.1-.173.201-.163l13.437 1.412c.1.011.173.101.163.202l-.041.393a6.938 6.938 0 1 1-13.8-1.45l.04-.394z",
    fill: "#A61C13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02F25",
    d: "m.301 4.709 13.404-3.592 6.585 24.574-13.404 3.592z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.407 19.083a4.337 4.337 0 1 0 0-8.673 4.337 4.337 0 0 0 0 8.673z",
    fill: "#000"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.407 19.083a4.337 4.337 0 1 0 0-8.673 4.337 4.337 0 0 0 0 8.673z",
    fill: "#F8C24A"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M10.407 19.083a4.337 4.337 0 1 0 0-8.673 4.337 4.337 0 0 0 0 8.673z",
    fill: "url(#c)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.41 18.94a4.192 4.192 0 1 0 0-8.383 4.192 4.192 0 0 0 0 8.383z",
    stroke: "#000",
    strokeOpacity: 0.097,
    strokeWidth: 0.289
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.407 17.927a3.183 3.183 0 0 1-3.18-3.18 3.184 3.184 0 0 1 3.18-3.18 3.185 3.185 0 0 1 3.063 4.037.256.256 0 0 1-.495-.138 2.67 2.67 0 0 0-2.569-3.386 2.67 2.67 0 0 0-2.666 2.666 2.67 2.67 0 0 0 3.478 2.541.257.257 0 1 1 .155.49c-.312.1-.638.15-.966.15zm.975-3.188c.11.092.184.225.222.399.025.1.024.205-.004.304a.616.616 0 0 1-.143.245.908.908 0 0 1-.251.185c-.099.05-.122.067-.24.093l-.074.018a.086.086 0 0 0-.063.102l.043.194a.086.086 0 0 1-.065.102l-.196.043a.085.085 0 0 1-.102-.065l-.043-.192a.086.086 0 0 0-.101-.066l-.53.118a.209.209 0 0 1-.25-.16l-.476-2.156a.209.209 0 0 1 .159-.248l.53-.117a.086.086 0 0 0 .065-.103l-.043-.194a.086.086 0 0 1 .065-.102l.196-.043a.087.087 0 0 1 .064.011.087.087 0 0 1 .038.054l.043.193a.086.086 0 0 0 .102.065l.162-.035a.52.52 0 0 1 .254.004c.08.022.153.059.218.109.13.105.222.25.258.415a.71.71 0 0 1-.015.367.595.595 0 0 1-.222.306.68.68 0 0 1 .4.154zm-1.57-.462.029.123a.209.209 0 0 0 .248.16l.378-.084a.265.265 0 0 0 .16-.104c.04-.054.05-.127.03-.218-.018-.085-.055-.145-.11-.18a.222.222 0 0 0-.177-.034l-.398.088a.209.209 0 0 0-.16.25zm1.13 1.09h.001a.275.275 0 0 0 .032-.216.315.315 0 0 0-.114-.187.221.221 0 0 0-.191-.045l-.479.106a.209.209 0 0 0-.159.248l.034.153a.21.21 0 0 0 .248.159l.454-.1a.265.265 0 0 0 .175-.119zm.954 1.556.443-.53a.08.08 0 0 0 .011-.085.08.08 0 0 0-.072-.047h-.299a.081.081 0 0 1-.056-.023.08.08 0 0 1-.024-.057v-.062a.08.08 0 0 1 .08-.08h.682a.08.08 0 0 1 .08.08v.082a.08.08 0 0 1-.017.05l-.424.532a.08.08 0 0 0 .062.13h.304a.08.08 0 0 1 .08.08v.063a.08.08 0 0 1-.049.074.079.079 0 0 1-.03.006h-.71a.078.078 0 0 1-.056-.024.08.08 0 0 1-.024-.056v-.081c0-.02.007-.038.02-.052z",
    fill: "#000"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.407 17.927a3.183 3.183 0 0 1-3.18-3.18 3.184 3.184 0 0 1 3.18-3.18 3.185 3.185 0 0 1 3.063 4.037.256.256 0 0 1-.495-.138 2.67 2.67 0 0 0-2.569-3.386 2.67 2.67 0 0 0-2.666 2.666 2.67 2.67 0 0 0 3.478 2.541.257.257 0 1 1 .155.49c-.312.1-.638.15-.966.15zm.975-3.188c.11.092.184.225.222.399.025.1.024.205-.004.304a.616.616 0 0 1-.143.245.908.908 0 0 1-.251.185c-.099.05-.122.067-.24.093l-.074.018a.086.086 0 0 0-.063.102l.043.194a.086.086 0 0 1-.065.102l-.196.043a.085.085 0 0 1-.102-.065l-.043-.192a.086.086 0 0 0-.101-.066l-.53.118a.209.209 0 0 1-.25-.16l-.476-2.156a.209.209 0 0 1 .159-.248l.53-.117a.086.086 0 0 0 .065-.103l-.043-.194a.086.086 0 0 1 .065-.102l.196-.043a.087.087 0 0 1 .064.011.087.087 0 0 1 .038.054l.043.193a.086.086 0 0 0 .102.065l.162-.035a.52.52 0 0 1 .254.004c.08.022.153.059.218.109.13.105.222.25.258.415a.71.71 0 0 1-.015.367.595.595 0 0 1-.222.306.68.68 0 0 1 .4.154zm-1.57-.462.029.123a.209.209 0 0 0 .248.16l.378-.084a.265.265 0 0 0 .16-.104c.04-.054.05-.127.03-.218-.018-.085-.055-.145-.11-.18a.222.222 0 0 0-.177-.034l-.398.088a.209.209 0 0 0-.16.25zm1.13 1.09h.001a.275.275 0 0 0 .032-.216.315.315 0 0 0-.114-.187.221.221 0 0 0-.191-.045l-.479.106a.209.209 0 0 0-.159.248l.034.153a.21.21 0 0 0 .248.159l.454-.1a.265.265 0 0 0 .175-.119zm.954 1.556.443-.53a.08.08 0 0 0 .011-.085.08.08 0 0 0-.072-.047h-.299a.081.081 0 0 1-.056-.023.08.08 0 0 1-.024-.057v-.062a.08.08 0 0 1 .08-.08h.682a.08.08 0 0 1 .08.08v.082a.08.08 0 0 1-.017.05l-.424.532a.08.08 0 0 0 .062.13h.304a.08.08 0 0 1 .08.08v.063a.08.08 0 0 1-.049.074.079.079 0 0 1-.03.006h-.71a.078.078 0 0 1-.056-.024.08.08 0 0 1-.024-.056v-.081c0-.02.007-.038.02-.052z",
    fill: "#fff"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M.15 4.15a.578.578 0 0 1 .408-.708L12.845.15c.309-.083.626.1.709.409l.15.558L.298 4.71.15 4.15zM6.883 29.281l13.404-3.591.15.558a.578.578 0 0 1-.41.708L7.742 30.25a.578.578 0 0 1-.709-.41l-.15-.558z",
    fill: "#ECBE2C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 5.781,
    y: 10.266,
    width: 9.25,
    height: 9.252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.145
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.145
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.199474 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1123_1992"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1123_1992",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 6.937,
    y: 11.422,
    width: 6.938,
    height: 6.938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.145
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.145
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.204257 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1123_1992"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1123_1992",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 10.407,
    y1: 10.41,
    x2: 10.407,
    y2: 19.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5.785 10.41)",
    d: "M0 0h9.251v9.251H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f6e7e237f46e5249fca3280bdedf8845.svg";
export { ForwardRef as ReactComponent };